import {Record, Map} from 'immutable';

import {makeReducer, match} from 'web-app/util/redux';
import {numbersToLetters} from 'web-app/util/string';
import NewLookTheme from 'web-app/styleguide/themes/new-look';

import * as Actions from './actions';
import {type Cohort} from './models';
import {COHORT_COLORS, ALL_CHILDREN_ID} from './constants';

const allChildrenCohort: Cohort = {
    id: ALL_CHILDREN_ID,
    color: NewLookTheme.textSecondary,
};

export interface CohortCompareStateProps {
    cohorts: Map<string, Cohort>;
    showAddCohortForm: boolean;
    index: number;
}
export class CohortCompareState extends Record<CohortCompareStateProps>({
    cohorts: Map({[allChildrenCohort.id]: allChildrenCohort}),
    showAddCohortForm: false,
    index: 0,
}) {}

export default makeReducer<CohortCompareState>(
    [
        match(Actions.addCohort, (state, {payload}) => {
            const id = numbersToLetters(state.index + 1);

            // Check if the object only contains undefined values, which means it's an all children selection
            const isAllChildrenCohort = Object.keys(payload.cohort).every(k => !payload.cohort[k]);

            if (isAllChildrenCohort) {
                return state.merge({
                    cohorts: state.cohorts.set(allChildrenCohort.id, {
                        id: allChildrenCohort.id,
                        color: allChildrenCohort.color,
                    }),
                    showAddCohortForm: false,
                    index: state.index + 1,
                });
            }

            return state.merge({
                cohorts: state.cohorts.set(id, {
                    ...payload.cohort,
                    id,
                    color: COHORT_COLORS.filter(color => !state.cohorts.some(cohort => cohort.color === color))[0],
                }),
                showAddCohortForm: false,
                index: state.index + 1,
            });
        }),
        match(Actions.removeCohort, (state, {payload}) =>
            state.merge({
                cohorts: state.cohorts.delete(payload.id),
            }),
        ),
        match(Actions.showAddCohortForm, state =>
            state.merge({
                showAddCohortForm: true,
            }),
        ),
        match(Actions.hideAddCohortForm, state =>
            state.merge({
                showAddCohortForm: false,
            }),
        ),
    ],
    new CohortCompareState(),
);
